export default "__VITE_ASSET__pqfpWH0e__"